export default __webpack_public_path__ + "b1fd98de53e91fd537cd8a035282430e.png";